const pickValue = (...values: Array<string | undefined>) => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim().length > 0) {
      return value.trim();
    }
  }
  return '';
};

export const BUSINESS_CONFIG = {
  companyName: pickValue(import.meta.env.VITE_BUSINESS_COMPANY_NAME, '밤랩 / BamLab'),
  ceoName: pickValue(import.meta.env.VITE_BUSINESS_CEO_NAME, '이승범'),
  address: pickValue(import.meta.env.VITE_BUSINESS_ADDRESS, '경기도 고양시 덕양구 서정마을로 25'),
  phone: pickValue(import.meta.env.VITE_BUSINESS_PHONE, '0507-1322-1922'),
  email: pickValue(import.meta.env.VITE_BUSINESS_EMAIL, 'lsbbb9797@gmail.com'),
  businessNumber: pickValue(import.meta.env.VITE_BUSINESS_NUMBER, '590-52-01118'),
  ecommerceNumber: pickValue(import.meta.env.VITE_BUSINESS_ECOMMERCE_NUMBER),
  hostingProvider: pickValue(import.meta.env.VITE_BUSINESS_HOSTING_PROVIDER, 'Cloudflare, Inc.'),
} as const;

export const BUSINESS_DISPLAY = {
  companyName: BUSINESS_CONFIG.companyName || '입력 필요',
  ceoName: BUSINESS_CONFIG.ceoName || '입력 필요',
  address: BUSINESS_CONFIG.address || '입력 필요',
  phone: BUSINESS_CONFIG.phone || '입력 필요',
  email: BUSINESS_CONFIG.email || '입력 필요',
  businessNumber: BUSINESS_CONFIG.businessNumber || '입력 필요',
  ecommerceNumber: BUSINESS_CONFIG.ecommerceNumber || '',
  hostingProvider: BUSINESS_CONFIG.hostingProvider || '입력 필요',
} as const;

export const isConfiguredBusinessInfo = [
  BUSINESS_CONFIG.companyName,
  BUSINESS_CONFIG.ceoName,
  BUSINESS_CONFIG.address,
  BUSINESS_CONFIG.phone,
  BUSINESS_CONFIG.email,
  BUSINESS_CONFIG.businessNumber,
].every((value) => value.length > 0);

export const hasReportedEcommerceNumber = BUSINESS_CONFIG.ecommerceNumber.length > 0;
